<i18n lang='yml' src='../i18n/BookingExamType.yml'></i18n>
<template>
  <div v-if="active">
    <flash :message_type="message_type" :message_text="message_text"/>
    <h5 class="margin-top heading-page">
      {{$t('details')}}
    </h5>
    <p>{{details.training_program_full_name}}</p>
    <Form class="form-inner" ref="observer" v-slot="{ errors }" @submit="nextStep" @invalid-submit="setErrorMessage">
        <fieldset class="form-group border-bottom">
          <div class="form-group row mb-4">
            <div class="numberCircle">1</div>
            <div class="col-10 col-lg-6 col-xl-4">
              <Field
                :name="$t('select_exam_type')"
                rules="required"
                v-slot="{ errors, field }"
                v-model="examType">
                <label :for="$t('select_exam_type')"> {{$t('select_exam_type')}} </label>
                <span class="red">*</span>
                <select :id="$t('select_exam_type')" class="select-dropdown custom-select form-control-sm" :class="{'is-invalid': errors[0]}" v-bind="field">
                  <option  v-for="(et, index) in examTypes" :key="index"  :value="et.id">
                    {{et.name[locale]}}
                  </option>
                </select>
                <div class="invalid-feedback" id="exam_type" v-if="errors[0]">
                  <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                  <span>{{ errors[0] }}</span> 
                </div>
              </Field>
            </div>
          </div>

          <div class="form-group row">
            <div class="numberCircle">2</div>
            <div class="col-10 col-lg-6 col-xl-4">
              <Field
                :name="$t('select_language')"
                rules="required"
                v-slot="{ errors, field }"
                v-model="language">
                <label :for="$t('select_language')"> {{$t('select_language')}} </label>
                <span class="red">*</span>
                <select :id="$t('select_language')" class="select-dropdown custom-select form-control-sm" :class="{'is-invalid': errors[0]}" v-bind="field">
                  <option value="English">
                    {{$t('english')}}
                  </option>
                  <option value="French">
                    {{$t('french')}}
                  </option>
                </select>
                <div class="invalid-feedback" id="language" v-if="errors[0]">
                  <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                  <span>{{ errors[0] }}</span> 
                </div>
              </Field>
            </div>
          </div>
      <div class="form-group row" v-if="admin == 'true'">
        <div class="numberCircle">3</div> 
          <div class="col-10">
            <label for="$t('accomodation_required')">{{$t('accomodation_required')}} </label>
            <span class="red">*</span>
            <p> 
              {{$t('accomodation_guiding_text_part_1')}}
              <a v-if="english_exam_prep_link || french_exam_prep_link" target="_blank" :href="locale == 'en' ? english_exam_prep_link : french_exam_prep_link">
                {{$t('guide')}}.
              </a>
              {{$t('accomodation_guiding_text_part_2')}}
            </p>
            <div class="col-sm-12">
                <div class="form-check form-check-inline" :class="{'is-invalid': errors[$t('accomodation_required')]}">
                  <label class="form-check-label" :for="`${$t('accomodation_required')}_true`">
                    <Field
                      :name="$t('accomodation_required')"
                      rules="required"
                      v-model="accomodation_required"
                      :id="`${$t('accomodation_required')}_true`"
                      value="true"
                      type="radio"/>
                    {{$t('yes_val')}}
                  </label>
                </div>
                <div class="form-check form-check-inline" :class="{'is-invalid': errors[$t('accomodation_required')]}">
                  <label class="form-check-label">
                    <Field
                      :name="$t('accomodation_required')"
                      rules="required"
                      v-model="accomodation_required"
                      :id="`${$t('accomodation_required')}_false`"
                      :aria-checked="`${$t('accomodation_required')}_false`"
                      value="false"
                      type="radio"/>
                    {{$t('no_val')}}
                  </label>
                </div>
                <div class="invalid-feedback" id="accomodation_required_error" v-if="errors[$t('accomodation_required')]">
                  <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                  <span>{{errors[$t('accomodation_required')] }}</span>
                </div>
            </div>
          </div>
        </div>
        </fieldset>
        <div v-if="Object.keys(errors).length > 0 && showErrorBanner" class="alert alert-danger" role="alert">
          <span class="red mr-2">
            <font-awesome-icon :icon="['far', 'exclamation-circle']"/>
          </span>
          {{ $t('error_warning') }}
        </div>
        <button type="submit" class="btn btn-primary btn-success no-shadow">
          <font-awesome-icon :icon="['fa', 'save']" />
          {{ $t('next') }}
        </button>
    </Form>
  </div>
</template>
<script>
import flash from '../../../shared/flash_messages/components/Flash.vue'
import { Form, Field } from 'vee-validate'
import { sendAjaxRequest } from '../../../shared/typescripts/ajax.ts';
import { setErrorMessage } from '../../../shared/typescripts/error.ts'
export default {
  components: { flash, Form, Field },
  props: ['locale', 'admin', 'base_path', 'training_program_id', 'details', 'active', 'french_exam_prep_link', 'english_exam_prep_link'],
  watch: {
    active(newVal) {
      if(newVal) {
        sendAjaxRequest('GET', `${this.base_path}/exam_types`, 'text', {training_program_id: this.training_program_id}, this.ajaxSuccess, this.ajaxError)
      }
    },
  },
  data() {
    return {
      examTypes: [],
      examType: null,
      language: null,
      accomodation_required: null,
      message_text: [],
      message_type: "",
      responses: [],
      showErrorBanner: false,
    }
  },
  methods: {
    nextStep() {
      const selectedExamType = this.examTypes.find(et => et.id === this.examType)
      if(selectedExamType) {
        this.$emit('examTypeChange', {
          'exam_type_id': selectedExamType.id,
          'exam_type_name': selectedExamType.name,
          'exam_fee': selectedExamType.current_fee
        })
        this.$emit('languageChange', {
          'language': this.language}
        )
        this.$emit('accommodationChange', {
          'accommodation': this.accomodation_required
        })
        this.$emit('nextStep')
      }
    },
    ajaxSuccess(data){
      this.loading = false;
      this.examTypes = JSON.parse(data);
      if (this.details.exam_type_id) {
        this.examType = this.details.exam_type_id
      }
      if (this.details.language) {
        this.language = this.details.language
      }
      if (this.details.accommodation != null) {
        this.accomodation_required = this.details.accommodation
      }
    },
    ajaxError() {
      this.loading = false;
      alert(this.$t('error_loading'));
    },
    setErrorMessage({ valuese, errors, results }) {
      setErrorMessage(this, errors, true)
    },
  },
}
</script>
